import React from "react";
import DOMPurify from "dompurify";

function HtmlRenderer({ htmlString="", className=""}) {
  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    // Allow target="_blank" on <a> tags
    if (node.tagName === "A") {
      node.setAttribute("target", "_blank");
    }
  });
  
  // Purify the input HTML string to prevent XSS
  const sanitizedHtml = DOMPurify.sanitize(htmlString);

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: sanitizedHtml,
      }}
    />
  );
}

export default HtmlRenderer;
